import { createMedia } from '@artsy/fresnel';
import breakpoints from '@/constants/breakpoints';

const AppMedia = createMedia({ breakpoints });

export const mediaStyles = AppMedia.createMediaStyle();
export const { Media, MediaContextProvider } = AppMedia;
